import { SaleOperationDataGetInvoiceDocumentHeaderConfigurationQuery } from "@sales/data/operation/SaleDataOperationQueries";
import InvoiceDocumentConfigurationForm from "../forms/InvoiceDocumentConfigurationForm"
import AgTechQueryLoadingSurface from "@agtech/core/data/queries/AgTechQueryLoadingSurface";
import { useAgTechQuery } from "@agtech/core/data/queries/AgTechDataQueries";

const InvoiceDocumentConfigurationPage = () => {
    let invoiceDocumentQuery = useAgTechQuery({
        query: SaleOperationDataGetInvoiceDocumentHeaderConfigurationQuery
    });

    return (
        <AgTechQueryLoadingSurface query={invoiceDocumentQuery}>
            {(invoiceDocHeader) => (
                <div className='stretched row-based container'>
                    <InvoiceDocumentConfigurationForm config={invoiceDocHeader}/>
                </div>
            )}
        </AgTechQueryLoadingSurface>
    )
}

export default InvoiceDocumentConfigurationPage